export enum BusySlot {
	OffHours = 'offHours',
	Intersection = 'intersection',
	IntersectionOverbooking = 'intersection-overbooking',
}
